(function () {
	angular
		.module('trackeye')
		.factory('ConfigurationService', ConfigurationService);

	ConfigurationService.$inject = ['ConfigurationCollection', 'Configuration', 'C4ApiService', '$q'];

	function ConfigurationService(ConfigurationCollection, Configuration, api, $q) {
		var collection = new ConfigurationCollection(),
			exports = {};

		/**
		 * Return a new Configuration instance, that has NOT been submitted.
		 * @param {string} name
		 * @param {string} description
		 * @param {object} data
		 * @returns {Configuration}
		 */
		exports.factory = function (name, description, data) {
			return (new Configuration(name, description)).setData(data);
		};

		/**
		 * Adds an instantiated configuration to the list
		 * @param {Configuration} config
		 */
		exports.add = function (config) {
			collection.add(config);
		};

		exports.delete = function (uuid) {
			return api.deleteConfiguration(uuid);
		};

		/**
		 *
		 * @param uuid
		 * @returns {Promise}
		 */
		exports.find = function (uuid) {
			var config = collection.find(uuid),
				defer = $q.defer();

			if (config && config.length) {
				defer.resolve(config);
			} else {
				api.getConfiguration(uuid).then(function (response) {
					collection.add(response.data);
					defer.resolve(collection.find(uuid));
				});
			}

			return defer.promise;
		};

		exports.findByName = function (name) {
			var config = collection.findByName(name),
				defer = $q.defer();

			if (config && config.length) {
				defer.resolve(config);
			} else {
				api.getConfiguration(name)
					.then(function (response) {
						collection.add(response.data);
						defer.resolve(collection.findByName(name));
					})
					.catch(defer.reject);
			}

			return defer.promise;
		};

		/**
		 * Finds a configuration by name
		 * @param {string} name
		 * @returns {Promise}
		 */
		exports.findOneByName = function (name) {
			var config = collection.findOneByName(name),
				defer = $q.defer();

			if (config && config.length) {
				defer.resolve(config);
			} else {
				api.getConfiguration(name)
					.then(function (response) {
						collection.add(response.data);
						defer.resolve(collection.findOneByName(name));
					})
					.catch(defer.reject);
			}

			return defer.promise;
		};

		exports.flush = function () {
			collection = new ConfigurationCollection();
		};

		return exports;
	}
}());